import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from "react";
export const AssetModalDesktopLayout = /*#__PURE__*/ memo((param)=>{
    let { arrows, panel, header, content } = param;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "fixed left-0 top-0 flex size-full flex-col items-start justify-start overflow-hidden bg-grey-2",
                children: [
                    header,
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex max-h-[calc(100%-90px)] min-h-0 w-full flex-1 items-start justify-start",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "flex h-full max-h-full flex-1 flex-col items-start justify-start",
                                children: content
                            }),
                            panel
                        ]
                    })
                ]
            }),
            arrows
        ]
    });
});
AssetModalDesktopLayout.displayName = "AssetModalDesktopLayout";
